// import { WrappedResourceDetailPage } from './lib/ResourceDetail';
import { WrappedResourceDetailPage } from './lib/ResourceDetail2';

export * from './lib/components';
export default WrappedResourceDetailPage;
